import { createSlice } from "@reduxjs/toolkit";
import { loginUserAction, sendPhoneOtp, loginByPhoneOtp, hydrateUser, logoutUserAction } from "../../actions/auth/authActions";

const initialState = {
  loading: false,
  data: null,
  user: null,
  isAuthenticated: false,
  hydrated: false,
  error: null,
  otpSent: false,
  otpLoading: false,
  otpError: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLogin: (state, { payload }) => {
      state.data = payload?.data;
      state.isAuthenticated = true;
      return state;
    },
    logOut: (state, action) => {
      state = { ...initialState, hydrated: true };
      return state;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(loginUserAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUserAction.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.user) {
          state.user = action.payload.user;
          state.data = action.payload;
          state.isAuthenticated = true;
        }
        return state;
      })
      .addCase(loginUserAction.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(sendPhoneOtp.pending, (state) => {
        state.otpLoading = true;
        state.otpError = null;
      })
      .addCase(sendPhoneOtp.fulfilled, (state) => {
        state.otpLoading = false;
        state.otpSent = true;
      })
      .addCase(sendPhoneOtp.rejected, (state, { payload }) => {
        state.otpLoading = false;
        state.otpError = payload;
      })
      .addCase(loginByPhoneOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginByPhoneOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.otpSent = false;
        if (action.payload?.user) {
          state.user = action.payload.user;
          state.data = action.payload;
        } else if (action.payload?.respondentName) {
          state.user = { name: action.payload.respondentName };
          state.data = action.payload;
        }
        return state;
      })
      .addCase(loginByPhoneOtp.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(hydrateUser.pending, (state, action) => {
        state.hydrated = false;
      })
      .addCase(hydrateUser.fulfilled, (state, action) => {
        state.hydrated = true;
        if (action.payload) {
          state.user = action.payload;
          state.isAuthenticated = true;
        } else {
          state.user = null;
          state.isAuthenticated = false;
        }
      })
      .addCase(hydrateUser.rejected, (state, action) => {
        state.hydrated = true;
        state.user = null;
        state.isAuthenticated = false;
        state.error = action.payload;
      })
      .addCase(logoutUserAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(logoutUserAction.fulfilled, (state, action) => {
        state.loading = false;
        state.user = null;
        state.data = null;
        state.isAuthenticated = false;
        state.error = null;
        state.otpSent = false;
      })
      .addCase(logoutUserAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }),
});

export const { setLogin, logOut } = authSlice.actions;
export const logout = logOut;
export default authSlice.reducer;
